import React from 'react';
import { FormGroup, FormControl, ControlLabel, Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';

import GroupWalls from '../../../../../../../components/GroupWalls';
import FormSwitch from '../../../../../../../components/FormSwitch';
import Tooltip from '../../../../../../../components/Tooltip';

const FieldsCommission = ({
  item,
  feeFromUser,
  showCommission,
  fixedPrice,
  fixedPercent,
  onBlurFixedPrice,
  onChangeFixedPrice,
  onChangeFixedPercent,
  setShowCommission,
}) => {
  if (!item?.details?.has_commission) return null;

  if (item?.details?.is_enabled_take_fee_from_user && feeFromUser === '1') {
    return null;
  }

  const label = item?.details?.charge_fee_after_payment ? 'Charge fee after payment' : 'Extra fee';
  const name = item?.details?.charge_fee_after_payment ? 'charge_fee_after_payment' : 'extra_fee';

  return (
    <FormGroup>
      <GroupWalls.Wrapper>
        <GroupWalls.Item active={showCommission}>
          <FormSwitch id={name} name={name} checked={showCommission} onChange={() => setShowCommission(!showCommission)}>
            {label}
            {' '}
            {item?.details?.charge_fee_after_payment && (
              <Tooltip
                placement="top"
                text={"The fee will be calculated and deducted from the user's balance after completing the payment and adding funds to the user's balance."}
                tooltipClass="tooltip__top"
              >
                <span className="fas fa-info-circle cursor-help" />
              </Tooltip>
            )}
          </FormSwitch>
          <Collapse in={showCommission}>
            <div>
              <FormGroup className="pt-12">
                <div className="input-group input-group__inline">
                  <div className="input__label-inside">
                    <ControlLabel className="top-label">Fixed (1.00)</ControlLabel>
                    <FormControl
                      type="text"
                      name="price_fixed"
                      id="price_fixed"
                      placeholder="0"
                      value={fixedPrice}
                      onBlur={onBlurFixedPrice}
                      onChange={onChangeFixedPrice}
                    />
                  </div>
                  <div className="input__label-inside">
                    <ControlLabel className="top-label">Percent (%)</ControlLabel>
                    <FormControl
                      type="text"
                      name="price_percent"
                      id="price_percent"
                      placeholder="0"
                      value={fixedPercent}
                      onChange={onChangeFixedPercent}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>
          </Collapse>
        </GroupWalls.Item>
      </GroupWalls.Wrapper>
    </FormGroup>
  );
};

FieldsCommission.propTypes = {
  item: PropTypes.object,
  feeFromUser: PropTypes.string,
  showCommission: PropTypes.bool,
  fixedPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fixedPercent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onBlurFixedPrice: PropTypes.func,
  onChangeFixedPrice: PropTypes.func,
  onChangeFixedPercent: PropTypes.func,
  setShowCommission: PropTypes.func,
};

export default FieldsCommission;
